export default "__VITE_ASSET__z6yevtDp__"